@for (comp of componentsArray; track comp) {
  <ng-template #dynamic></ng-template>
}